import { Box, Text } from 'roo-ui/components';
import { toDisplayDateFormat } from 'lib/utils';
import { ListBooking } from 'types';
import { Label } from '../Label';

interface CancellationLabelProps {
  booking: ListBooking;
}

export const CancellationLabel = ({ booking }: CancellationLabelProps) => {
  const activeCancellationWindow = booking.reservation.cancellationPolicy?.activeCancellationWindow;

  if (activeCancellationWindow?.isNonRefundable) {
    return (
      <Box minWidth="180px" mt={6} mr={4}>
        <Text color="greys.steel" fontSize={16}>
          Non-refundable
        </Text>
      </Box>
    );
  }

  if (!booking.flags.isCancelled && activeCancellationWindow && activeCancellationWindow.isFullyRefundable) {
    const labelText = `before ${toDisplayDateFormat(activeCancellationWindow.endTime)}`;
    return (
      <Box minWidth="180px" mt={6} mr={4}>
        <Label heading="Free cancellation" message={labelText} iconName="freeCancellation" />
      </Box>
    );
  }

  return null;
};
